import { render, staticRenderFns } from "./CheckComponent.vue?vue&type=template&id=f14ab07e&scoped=true&"
import script from "./CheckComponent.vue?vue&type=script&lang=js&"
export * from "./CheckComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14ab07e",
  null
  
)

export default component.exports